const DataWrap = Object.freeze({
  text: { value: 'text' },
  email: { value: 'email' },
  longtext: { value: 'longtext' },
  date: { value: 'date' },
  relativeDate: { value: 'relativeDate' },
  url: { value: 'url' },
  chip: { value: 'chip' },
  select: { value: 'select' },
  files: { value: 'files' },
  image: { value: 'image' },
  custom: { value: 'custom' },
})
// create an array of values
// [ 'text', 'email', 'longtext', 'date', 'relativeDate', 'url', 'chip', 'files', 'image', 'custom' ]
const DataWrapArray = Object.values(DataWrap).map(item => item.value)

const InputWrap = Object.freeze({
  text: { value: 'text' },
  textarea: { value: 'textarea' },
  number: { value: 'number' },
  checkbox: { value: 'checkbox' },
  switch: { value: 'switch' },
  radio: { value: 'radio' },
  file: { value: 'file' },
  date: { value: 'date' },
  time: { value: 'time' },
  select: { value: 'select' },
  autoComplete: { value: 'autoComplete' },
  combobox: { value: 'combobox' },
  slider: { value: 'slider' },
  dateRange: { value: 'dateRange' },
  rangeSlider: { value: 'rangeSlider' },
})

const InputWrapArray = Object.values(InputWrap).map(item => item.value)

export {
  DataWrap,
  InputWrap,
  DataWrapArray,
  InputWrapArray
}